import React from 'react';
import { costFormat } from 'src/utils/CommonUtils';

const FinalProfitLoss = ({
  netProfit,
  netCost,
  netCreditedAmount,
  profitandlosspercentage,
  actualProfitPercentage
}) => {

  // Helper function to detect negative value  
  const getColor = (value) => {
    return value.toString().includes('-') ? 'red' : 'green';
  };
  const devPercentage = ((netCreditedAmount - netCost - netProfit) / netProfit * 100).toFixed(2)
  return (
    <div style={{ padding: '20px', border: "1px solid #e5e7eb", borderRadius: "8px", marginTop: '20px', background: '#faf8fc' }}>

      {/* Main Heading */}
      <div style={{ fontSize: "18px", fontWeight: 600, color: "#0A1929" }}>
        Final Profit & Loss
      </div>

      {/* BLOCK 1 */}
      <div className='mb-3'>
        <div style={{ fontSize: "14px", fontWeight: '500', marginBottom: "7px", color: "#6B7280" }}>
          Profit & Loss Amount
        </div>

        <div
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: '15px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'start'
          }}
        >
          {/* Ideal */}
          <div style={{ fontSize: "14px", width: '100%', fontWeight: '600' }}>
            Ideal
            <span
              className='d-block'
              style={{ color: getColor(netProfit), fontSize: '18px', fontWeight: '600' }}
            >
              {costFormat(netProfit)}
            </span>
          </div>

          {/* Actual */}
          <div style={{ fontSize: "14px", width: '100%', fontWeight: '600' }}>
            Actual
            <span
              className='d-block'
              style={{ color: getColor(netCreditedAmount === 0 ? "NA" : costFormat(netCreditedAmount - netCost)), fontSize: '18px', fontWeight: '600' }}
            >
              {netCreditedAmount === 0 ? "NA" : costFormat(netCreditedAmount - netCost)}               
            </span>
          </div>

          {/* Deviation */}
          <div style={{ fontSize: "14px", width: '100%', fontWeight: '600' }}>
            Deviation
            <span
              className='d-block'
              style={{ color: getColor(netCreditedAmount === 0 ? "NA" : costFormat(netCreditedAmount - netCost - netProfit)), fontSize: '18px', fontWeight: '600' }}
            >
              {netCreditedAmount === 0 ? "NA" : costFormat(netCreditedAmount - netCost - netProfit)}
            </span>
          </div>
        </div>
      </div>

      {/* BLOCK 2 */}
      <div>
        <div style={{ fontSize: "14px", fontWeight: '500', color: "#6B7280", marginBottom: "7px" }}>
          Profit & Loss Margin (%)
        </div>

        <div
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: '15px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'start'
          }}
        >
          {/* Ideal */}
          <div style={{ fontSize: "14px", width: '100%', fontWeight: '600' }}>
            Ideal
            <span
              className='d-block'
              style={{ color: getColor(profitandlosspercentage), fontSize: '18px', fontWeight: '600' }}
            >
              {profitandlosspercentage}%
            </span>
          </div>

          {/* Actual */}
          <div style={{ fontSize: "14px", width: '100%', fontWeight: '600' }}>
            Actual
            <span
              className='d-block'
              style={{ color: getColor(actualProfitPercentage), fontSize: '18px', fontWeight: '600' }}
            >
              {actualProfitPercentage}%
            </span>
          </div>

          {/* Deviation */}
          <div style={{ fontSize: "14px", width: '100%', fontWeight: '600' }}>
            Deviation
            <span
              className='d-block'
              style={{ color: getColor(devPercentage), fontSize: '18px', fontWeight: '600' }}
            >
              {netCreditedAmount === 0 ? 'NA' : devPercentage}%
            </span>
          </div>
        </div>
      </div>

    </div>
  );
};

export default FinalProfitLoss;
